import Vue from "vue"
import "@/plugins/dayjs"
import "@/plugins/fontawesome"

import App from "./App.vue"
import router from "./router"
import store from "./store"
import vuetify from "./plugins/vuetify"
import money from "./plugins/v-money"
import VueLazyload from "vue-lazyload"
import VueSignaturePad from "vue-signature-pad"
import ButtonModule from "@/components/button"
import PaymentModule from "@/components/paymentplan"
import LayoutModule from "@/components/layout"
import DirectiveModule from "@/directives"
import DownpaymentModule from "@/components/downpayment"
import FilterModule from "@/filter"
import FormModule from "@/components/form"
import ImageModule from "@/components/image"
import NavigationPlugin from "@/plugins/navigation-plugin"
import ProgressModule from "@/components/progress"
import SignatureModule from "@/components/signature"
import TooltipModule from "@/components/tooltip"
import {i18n, loadStateLocalesAsync} from "@/plugins/i18n"

Vue.use(PaymentModule)
Vue.use(ButtonModule)
Vue.use(DirectiveModule)
Vue.use(DownpaymentModule)
Vue.use(FormModule)
Vue.use(FilterModule)
Vue.use(ImageModule)
Vue.use(NavigationPlugin)
Vue.use(ProgressModule)
Vue.use(SignatureModule)
Vue.use(TooltipModule)
Vue.use(VueSignaturePad)
Vue.use(money, { precision: 0 })
Vue.use(VueLazyload)
Vue.use(LayoutModule)

Vue.config.productionTip = false

import { sessionService } from "@/service"
import {learnHowState, sessionState} from "@/state"



store.commit("initializeStore")


new Vue({
    router,
    store,
    vuetify,
    i18n,
    watch:{
        $route (to, from) {
            if (from.path !== to.path) {
                sessionService.clearTemporaryTimeoutMillis()
            }

            if (to.path?.startsWith("/start")) {
                store.commit("clearStorage")
            }
            learnHowState.hideDrawer()
        }
    },
    async beforeCreate() {
        // should add language support to session in future if needed
        const defaultLanguage = "en"
        await loadStateLocalesAsync(defaultLanguage, sessionState?.session?.properties?.state?.toLowerCase())
    },
    created() {
        window.addEventListener("beforeunload", e => {
            //Trigger if there is a webSessionId and not loading store from storage
            if ( sessionState.session.webSessionId && process.env.VUE_APP_LOAD_STORE_FROM_STORAGE !== "true") {
                //Preventing default triggers the confirm message if page has be interacted with
                e.preventDefault()
                //Most browsers no longer support custom confirm messages, but this will set it for those that do
                return "WARNING: Refreshing this page will require you to restart the application process and re-scan the QR code.  Are you sure you want to continue?"
            }
        })
    },
    render: h => h(App)
}).$mount("#app")
